import { render, staticRenderFns } from "./kw_px_edit.vue?vue&type=template&id=41be674a&scoped=true&"
import script from "./kw_px_edit.vue?vue&type=script&lang=js&"
export * from "./kw_px_edit.vue?vue&type=script&lang=js&"
import style0 from "./kw_px_edit.vue?vue&type=style&index=0&id=41be674a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be674a",
  null
  
)

component.options.__file = "kw_px_edit.vue"
export default component.exports